jQuery(document).ready(function ($) {

    $('#btn-mobile').on('click', function(){
        $('.nav-menu-links>ul').slideToggle();
    });

    $('#btn-search').on('click', function(){
        $('#search-form').slideToggle();
    });

    /* MASK JQUERY */
    $('.mask-date').mask('00/00/0000');
    $('.mask-time').mask('00:00:00');
    $('.mask-dateTime').mask('00/00/0000 00:00:00');
    $('.mask-cep').mask('00000-000');
    $('.mask-cpf').mask('000.000.000-00');
    $('.mask-cnpj').mask('00.000.000/0000-00');
    $('.mask-money').mask('000.000.000.000.000,00', { reverse: true });
    var CelMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
        celOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(CelMaskBehavior.apply({}, arguments), options);
            }
        };
    $('.mask-tel').mask(CelMaskBehavior, celOptions);
});